export const SAVE_APPLY_LOAN_PROGRESS = 'SAVE_APPLY_LOAN_PROGRESS' // 保存贷款流程进度

export const GET_STEP1_INITIAL_STATE = 'GET_STEP1_INITIAL_STATE'
export const GET_STEP1_INITIAL_DATA = 'GET_STEP1_INITIAL_DATA'
export const SET_STEP1_INITIAL_DATA = 'SET_STEP1_INITIAL_DATA'
export const SAVE_STEP1_DATA = 'SAVE_STEP1_DATA'

export const GET_SAVED_STEP1_DATA = 'GET_SAVED_STEP1_DATA'

export const GET_CONFIRM_LOAN_DATA_STATE = 'GET_CONFIRM_LOAN_DATA_STATE'
export const GET_CONFIRM_LOAN_DATA = 'GET_CONFIRM_LOAN_DATA'
export const SET_CONFIRM_LOAN_DATA = 'SET_CONFIRM_LOAN_DATA'
export const SET_STEP1_INITIAL_DATA_REPAY_TYPE = 'SET_STEP1_INITIAL_DATA_REPAY_TYPE'

// 获取借款数据tan
export const GET_LOAN_DATA_STATE = 'GET_LOAN_DATA_STATE'
export const GET_LOAN_DATA = 'GET_LOAN_DATA'
export const GET_LOAN_DATA_CTL = 'GET_LOAN_DATA_CTL'
export const GET_LOAN_DATA_SBL = 'GET_LOAN_DATA_SBL'
export const SET_LOAN_DATA_STATE = 'SET_LOAN_DATA_STATE'

//step1 定义借款期限 Loan Term   hgwn 4/16  hs_2
export const GET_LOAN_LIMIT_DATA_STATE = 'GET_LOAN_LIMIT_DATA_STATE'
export const GET_LOAN_LIMIT_DATA = 'GET_LOAN_LIMIT_DATA'
export const SET_LOAN_LIMIT_DATA_STATE = 'SET_LOAN_LIMIT_DATA_STATE'




// WEBPACK FOOTER //
// ./src/vuex/types/applyLoan/step1.js